import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'msh-loading-logo',
  imports: [],
  template: `
    <div class="loader"></div>
  `,
  styles: `
  :root {
    display: block;
    width: 100%;
    height: 100%;
  }
  `
})
export class LoadingLogoComponent {
  private store = inject(Store)
}
